module.exports = __webpack_public_path__ + "img/wide.0058f626.png";